import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import {
  IEmailTemplate,
  IEmailTemplateSummary,
  ICommunication,
} from "./emailTemplates.types"
import {
  GetEmailTemplateSummariesQuery,
  GetEmailTemplatesByCommunicationQuery,
  GetCommunicationsQuery,
} from "@/api/hasura/generated/graphql"
import { dayjsOrNull } from "@/helpers/dateHelper"

export type IEmailTemplateSummaryRaw =
  GetEmailTemplateSummariesQuery["email_templates"][0]
export type IEmailTemplateRaw =
  GetEmailTemplatesByCommunicationQuery["email_templates"][0]
export type ICommunicationRaw = GetCommunicationsQuery["communications"][0]

function toCommunication(
  data: IEmailTemplateSummaryRaw["communication"],
): ICommunication {
  return {
    id: Number(data.id),
    name: data.name,
    communicationType: String(data.communication_type),
  }
}

export const CommunicationParser: IParser<ICommunication, ICommunicationRaw> = {
  toDomain(data: ICommunicationRaw): ICommunication {
    try {
      return toCommunication(data)
    } catch (error) {
      throw new ParseError(error)
    }
  },
}

export const EmailTemplateSummaryParser: IParser<
  IEmailTemplateSummary,
  IEmailTemplateSummaryRaw
> = {
  toDomain(data: IEmailTemplateSummaryRaw): IEmailTemplateSummary {
    try {
      return {
        id: Number(data.id),
        communicationId: Number(data.communication_id),
        version: data.version,
        isLive: data.is_live,
        subject: data.subject,
        createdAt: dayjsOrNull(data.created_at),
        publishedAt: dayjsOrNull(data.published_at),
        modifiedBy: data.modified_by ?? null,
        communication: toCommunication(data.communication),
      }
    } catch (error) {
      throw new ParseError(error)
    }
  },
}

export const EmailTemplateParser: IParser<IEmailTemplate, IEmailTemplateRaw> = {
  toDomain(data: IEmailTemplateRaw): IEmailTemplate {
    try {
      return {
        id: Number(data.id),
        communicationId: Number(data.communication_id),
        version: data.version,
        isLive: data.is_live,
        subject: data.subject,
        plainContent: data.plain_content,
        htmlContent: data.html_content,
        modifiedBy: data.modified_by ?? null,
        modifiedReason: data.modified_reason ?? null,
        createdAt: dayjsOrNull(data.created_at),
        publishedAt: dayjsOrNull(data.published_at),
        communication: toCommunication(data.communication),
      }
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
